import React from 'react';
import styles from './PillTabs.module.scss';
import { Chip, styled } from '@mui/material';
import { interpolateCSSVariable } from 'new/theme';

export type PillTab = {
  label: string;
  value: string;
};

interface PillTabsProps {
  tabs: PillTab[];
  multiple?: boolean;
  onSelectionChange: (control: string | string[]) => void;
  selected: string | string[];
}

const Tab = styled(Chip)(({ theme, variant }) => ({
  height: '24px',
  ...(variant === 'filled' && {
    backgroundColor: theme.palette.primary.light,
    border: '1px solid ' + interpolateCSSVariable('--color-primary-200'),
    color: theme.palette.primary.main,
  }),
  ...(variant === 'outlined' && {
    backgroundColor: 'transparent',
    border: '1px solid ' + interpolateCSSVariable('--color-primary-200'),
    color: theme.palette.primary.main,
  }),
}));

export function PillTabs(props: PillTabsProps) {
  const { tabs, onSelectionChange, selected, multiple } = props;

  const onClick = (value) => () => {
    if (multiple) {
      if (selected.includes(value) && Array.isArray(selected)) {
        onSelectionChange([...selected.filter((s) => s !== value)]);
        return;
      } else {
        onSelectionChange([...selected, value]);
        return;
      }
    }
    onSelectionChange(value);
  };

  const isSelected = (value) => {
    if (Array.isArray(selected)) {
      return selected.includes(value);
    }
    return value === selected;
  };

  return (
    <div className={styles.container}>
      {tabs.map((control) => (
        <Tab
          key={control.value}
          variant={isSelected(control.value) ? 'filled' : 'outlined'}
          label={control.label}
          onClick={onClick(control.value)}
        />
      ))}
    </div>
  );
}
